import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/typography/typography.external-styles.ts
var typography_external_styles_default = r` fadv-typography fadv-typography::part(base) { display: inline; } `;

export {
  typography_external_styles_default
};
